<template>
  <el-dialog
    :title="$t('resetMallUserPwd.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align:center;">
      {{ $t('resetMallUserPwd.confirmContent') }}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="resetMallUserPwd">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resetMallUserPwd } from '@/api/user/mallUserApi'

export default {
  name: 'ResetMallUserPwd',
  data() {
    return {
      dialogVisible: false,
      currentUser: null
    }
  },
  methods: {
    open(user) {
      this.currentUser = user
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async resetMallUserPwd() {
      try {
        const res = await resetMallUserPwd({ userId: this.currentUser.userId })
        if (res.code === 0) {
          this.$message.success(
            this.$t('resetMallUserPwd.success  '+res.pwd, { pwd: res.pwd }),
            10000
          )
          this.closeDialog()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('重置密码失败:', error)
        this.$message.error(this.$t('resetMallUserPwd.error'))
      }
    }
  }
}
</script>